<template>
    <div class="help-center-video-preview" @click="openVideo">
        <div class="tutorials-video-preview">
            <div class="tutorials-video-overlay">
                <i class="fa fa-youtube-play" />
            </div>

            <img :src="video.previewImageUrl" alt="" />
        </div>
        <div class="tutorials-video-about">
            <span class="video-heading">
                {{ video.title }}
            </span>
        </div>
    </div>
</template>

<script>
import UIUtils from '../../../../business/utils/UIUtils'

export default {
    name: 'HelpCenterVideoPreview',
    props: {
        video: {
            type: Object,
            required: true
        }
    },
    methods: {
        openVideo() {
            UIUtils.showModal('video_tutorial', data => {
                data.componentTutorial = [this.video]
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.help-center-video-preview {
    .tutorials-video-preview {
        cursor: pointer;
        position: relative;

        .tutorials-video-overlay {
            height: 100%;
            width: 100%;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.2);

            i.fa {
                position: absolute;
                text-align: center;
                top: calc(50% - 25pt);
                left: calc(50% - 25pt);
                font-size: 50pt;
                opacity: 0.8;
            }
        }

        img {
            width: 100%;
            max-width: 100%;
        }
    }

    .tutorials-video-about {
        cursor: pointer;
        background: $dark-3;
        text-align: center;
        color: #fff;
        font-size: 1rem;
        font-weight: normal;
        padding: 0.75rem 0;
        transition: all 0.2s;
        flex: 1;

        .video-heading {
            display: block;
            margin-bottom: 0.5rem;
        }
    }
    &:hover {
        .tutorials-video-about {
            background: $dark-2;
        }
    }
}
</style>
